export var fullWidthMessageBarStyle = {
    root: {
        borderRadius: '0',
    },
};
export var getMessageBarStyles = function (props) {
    var theme = props.theme;
    var effects = theme.effects;
    return {
        root: {
            borderRadius: effects.roundedCorner4,
        },
    };
};
//# sourceMappingURL=MessageBar.styles.js.map